<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/brcOl7/media/FC-9781398443907.jpg?1708093998628" alt="This image is the cover for the book It's a Good Life If You Don't Weaken"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">It's a Good Life If You Don't Weaken
      </h1>
      <p class="bookDescription body article font2">
        <p>Life in the 1950s and 60s sometimes appears to have been lived by people from another planet. Such is the difference in lifestyle between now and then. Computers, social media, and all the problems that come with living in the 21st century were a distant dream (or nightmare). Life was lived at a slower pace, and people had more time for one another. This is not to say that times couldn't be hard, and life certainly wasn’t always a ‘bed of roses’. Through it all, there was always a shoulder to lean on, or a nice cup of tea made by a friend or neighbour, who would listen patiently to your troubles or triumphs (counsellors extraordinaire!) There appeared to be no shortage of characters, and everyone had a tale to tell. ‘A peck of dirt won’t kill you,’ was a well-used adage, and from childhood to old age, people were less fearful than today, thus allowing them to live their lives to the full. This book is about the people who lived through those times, their quirks and habits, their generosity and good humour. Humour plays a big part in this book, with a sprinkling of every other human emotion. The author sincerely hopes that young and old will enjoy looking back at a bygone time which was only 60 short years ago.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Holmes
      </h2>
      
      <p class="authorDescription body article">David was born in Rochford, Essex in 1950. He has been happily married to Heather for 41 years and has three children and four grandchildren. He ran his own wholesale coffee business for 35 years and also worked part-time in a crisis and assessment unit with young vulnerable people. David played rugby for Colchester and Mersea clubs, and tennis for his local club. The author now enjoys playing bowls and watching a variety of sports. David loves spending time with his family and is very proud of their various achievements. He also enjoys a pint with friends on his beloved Mersea Island.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?aa187c30